import { Route } from 'react-router-dom';

import {
    AUCTION_PAGE_ROUTE,
    CAMPAIGN_CREATE_URL,
    CAMPAIGN_QUICK_CREATE_URL, // exp_PORTFOLIO-58018_next_line
    CAMPAIGN_VR_CREATE_URL,
    CAMPAIGNS_DASHBOARD_PAGE_ROUTE,
    DASHBOARD_PAGE_ROUTE,
    HELP_PAGE_URL,
    MULTI_CREATION_ROUTE,
    TOP_UP_PAGE_ROUTE,
} from 'utils/constants/app';
import { BANNER_ID_URL_FIELD_NAME } from 'utils/constants/banner';
import { CAMPAIGN_ID_URL_FIELD_NAME, CAMPAIGNS_CURRENT_TAB_URL_FIELD_NAME } from 'utils/constants/campaign';

import AdminRoute from 'app/routes/AdminRoute';
import { ModeratorRoute } from 'app/routes/ModeratorRoute/ModeratorRoute';
import { RouteType } from 'app/routes/routeType';
import UserRoute from 'app/routes/UserRoute';

import { AccountCreatePage } from 'pages/AccountCreatePage/AccountCreatePage';
import { AccountCreateRequirements } from 'pages/AccountCreatePage/requirements';
import { AccountsControlPage } from 'pages/AccountsControlPage/AccountsControlPage';
import { AccountsControlRequirements } from 'pages/AccountsControlPage/requirements';
import AccountStatisticsReport from 'pages/AccountStatisticsReport';
import ActsReport from 'pages/ActsReport';
import ActsSummaryReport from 'pages/ActsSummaryReport/ActsSummaryReport';
import { AdCopyPage } from 'pages/AdCopyPage/AdCopyPage';
import { AdCopyPageRequirements } from 'pages/AdCopyPage/requirements';
import AdCreateMenu from 'pages/AdCreateMenu';
import AdCreateMenuRequirements from 'pages/AdCreateMenu/requirements';
import AdminRequirements from 'pages/adminRequirements';
import { AdQuickCreate } from 'pages/AdQuickCreate';
import AdQuickCreateRequirements from 'pages/AdQuickCreate/requirements';
import { AuctionBuilderPage } from 'pages/AuctionBuilderPage/AuctionBuilderPage';
import { AuctionBuilderRequirements } from 'pages/AuctionBuilderPage/requirements';
import { BalanceAndBonusesPage } from 'pages/BalanceAndBonusesPage/BalanceAndBonusesPage';
import { BalanceAndBonusesRequirements } from 'pages/BalanceAndBonusesPage/requirements';
import { BannerBuilderPage } from 'pages/BannerBuilderPage/BannerBuilderPage';
import { BannerBuilderPageRequirements } from 'pages/BannerBuilderPage/requirements';
import { BannerModerationInfoPage } from 'pages/BannerModerationInfoPage/BannerModerationInfoPage';
import { BannersPage } from 'pages/BannersPage/BannersPage';
import { BannersPageRequirements } from 'pages/BannersPage/requirements';
import BillingFunnelReport from 'pages/BillingFunnelReport';
import { CampaignsDashboardPage } from 'pages/CampaignsDashboardPage/CampaignsDashboardPage';
import { CampaignsDashboardRequirements } from 'pages/CampaignsDashboardPage/requirements';
import CampaignsReport from 'pages/CampaignsReport';
import { CpcFlexibleBuilderPage } from 'pages/CpcFlexibleBuilderPage/CpcFlexibleBuilderPage';
import { CpcFlexibleBuilderPageRequirements } from 'pages/CpcFlexibleBuilderPage/requirements';
import CrmActivities from 'pages/CrmActivities';
import CrmActivitiesRequirements from 'pages/CrmActivities/requirements';
import CrmActivity from 'pages/CrmActivity';
import CrmActivityRequirements from 'pages/CrmActivity/requirements';
import Dashboard from 'pages/Dashboard';
import DashboardRequirements from 'pages/Dashboard/requirements';
import EditingActs from 'pages/EditingActs';
import EfficiencyReport from 'pages/EfficiencyReport';
import EmptyRequirements from 'pages/emptyRequirements';
import EngineeringWorks from 'pages/EngineeringWorks';
import Forbidden from 'pages/Forbidden';
import IncomeExpenseReport from 'pages/IncomeExpenseReport';
import InvoiceDetail from 'pages/InvoiceDetail';
import InvoiceDetailRequirements from 'pages/InvoiceDetail/requirements';
import Invoices from 'pages/Invoices';
import LoginPage from 'pages/LoginPage';
import ManualChargesReport from 'pages/ManualChargesReport';
import { ModerationListPage } from 'pages/ModerationListPage/ModerationListPage';
import { ModerationListPageRequirements } from 'pages/ModerationListPage/requirements';
import { ModerationReasonsListPage } from 'pages/ModerationReasonsListPage/ModerationReasonsListPage';
import { ModerationReasonsListPageRequirements } from 'pages/ModerationReasonsListPage/requirements';
import { ModeratorRequirements } from 'pages/moderatorRequirements';
import { MultiCreationAuctionPage } from 'pages/MultiCreationAuctionPage/MultiCreationAuctionPage';
import MultiCreationAuctionRequirements from 'pages/MultiCreationAuctionPage/requirements';
import NotFound from 'pages/NotFound';
import OverflowReport from 'pages/OverflowReport';
import PayerCreate from 'pages/PayerCreate';
import PayerCreateRequirements from 'pages/PayerCreate/requirements';
import PayerDetail from 'pages/PayerDetail';
import PayerDetailRequirements from 'pages/PayerDetail/requirements';
import Payers from 'pages/Payers';
import PayersRequirements from 'pages/Payers/requirements';
import { PromoCodesPage } from 'pages/PromoCodes';
import { PromoCodesRequirements } from 'pages/PromoCodes/requirements';
import ServerError from 'pages/ServerError';
import Statistic from 'pages/Statistic';
import StatisticRequirements from 'pages/Statistic/requirements';
import { SubscriptionSettingsRequirements } from 'pages/SubscriptionSettingsPage/requirements';
import { SubscriptionSettingsPage } from 'pages/SubscriptionSettingsPage/SubscriptionSettingsPage';
import SuperAdminRequirements from 'pages/superAdminRequirements';
import Translations from 'pages/Translations';
import Unavailable from 'pages/Unavailable';
import { UserDetailRequirements } from 'pages/UserDetailPage/requirements';
import { UserDetailPage } from 'pages/UserDetailPage/UserDetailPage';
import UserRequirements from 'pages/userRequirements';
import { UsersPage } from 'pages/UsersPage/UsersPage';
// exp_PORTFOLIO-58018_start
import { VrCampaignBuilderPageRequirements } from 'pages/VrCampaignBuilderPage/requirements';
import { VrCampaignBuilderPage } from 'pages/VrCampaignBuilderPage/VrCampaignBuilderPage';
// exp_PORTFOLIO-58018_end
import { YandexDirectReportPage } from 'pages/YandexDirectReportPage/YandexDirectReportPage';

import LandingPageStub from 'components/LandingPage';

import { CampaignsTab } from 'store/models/campaignsDashboard';
import { CampaignTabStatus } from 'store/models/dashboard';

export const ROUTE_COMPONENTS = {
    [RouteType.SuperAdminRoute]: AdminRoute,
    [RouteType.AdminRoute]: AdminRoute,
    [RouteType.UserRoute]: UserRoute,
    [RouteType.PublicRoute]: Route,
    [RouteType.ExternalRedirect]: Route,
    [RouteType.InternalRedirect]: Route,
    [RouteType.ModeratorRoute]: ModeratorRoute,
};

export const ROUTES_REQUIREMENTS = {
    [RouteType.SuperAdminRoute]: SuperAdminRequirements,
    [RouteType.AdminRoute]: AdminRequirements,
    [RouteType.UserRoute]: UserRequirements,
    [RouteType.PublicRoute]: EmptyRequirements,
    [RouteType.ExternalRedirect]: EmptyRequirements,
    [RouteType.InternalRedirect]: EmptyRequirements,
    [RouteType.ModeratorRoute]: ModeratorRequirements,
};

export const NotFoundRoute = {
    title: 'notFound.title',
    component: NotFound,
    path: '/new/not-found/',
    pageName: 'clickme_not_found',
    type: RouteType.UserRoute,
    exact: false,
    xs: true,
};

export default [
    {
        title: 'dashboard.title.text',
        component: Dashboard,
        path: DASHBOARD_PAGE_ROUTE,
        pageName: 'clickme_my_campaigns',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        xs: true,
        ...DashboardRequirements(CampaignTabStatus.Active),
    },
    {
        title: 'dashboard.title.text',
        component: Dashboard,
        path: `${DASHBOARD_PAGE_ROUTE}archive`,
        pageName: 'clickme_my_archive_campaigns',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        xs: true,
        ...DashboardRequirements(CampaignTabStatus.Off),
    },
    {
        title: 'campaignsDashboard.title',
        path: CAMPAIGNS_DASHBOARD_PAGE_ROUTE,
        type: RouteType.InternalRedirect,
        exact: true,
        to: `${CAMPAIGNS_DASHBOARD_PAGE_ROUTE}${CampaignsTab.Active}`,
    },
    {
        title: 'campaignsDashboard.title',
        component: CampaignsDashboardPage,
        path: `${CAMPAIGNS_DASHBOARD_PAGE_ROUTE}:${CAMPAIGNS_CURRENT_TAB_URL_FIELD_NAME}`,
        pageName: 'clickme_campaigns_dashboard',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        xs: true,
        ...CampaignsDashboardRequirements(),
    },
    {
        title: 'adCreateMenu.pageTitle',
        component: AdCreateMenu,
        path: '/new/create/menu/',
        pageName: 'clickme_create_campaign_menu',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        xs: true,
        ...AdCreateMenuRequirements,
    },
    {
        title: 'AdCreate.pageTitle',
        component: CpcFlexibleBuilderPage,
        path: CAMPAIGN_CREATE_URL,
        pageName: 'clickme_create_campaign_flexible',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...CpcFlexibleBuilderPageRequirements,
    },
    {
        title: 'AdCreate.pageTitle',
        component: AdQuickCreate,
        path: CAMPAIGN_QUICK_CREATE_URL,
        pageName: 'clickme_create_campaign_quick',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...AdQuickCreateRequirements,
    },
    // exp_PORTFOLIO-58018_start
    {
        title: 'AdCreate.pageTitle',
        component: VrCampaignBuilderPage,
        path: CAMPAIGN_VR_CREATE_URL,
        pageName: 'clickme_create_campaign_vr',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...VrCampaignBuilderPageRequirements,
    },
    // exp_PORTFOLIO-58018_end
    {
        title: 'AdCreate.pageTitle',
        component: AuctionBuilderPage,
        path: AUCTION_PAGE_ROUTE,
        pageName: 'clickme_create_campaign_auction',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...AuctionBuilderRequirements,
    },
    {
        title: 'MultiCreationAuctionPage.pageTitle',
        component: MultiCreationAuctionPage,
        path: MULTI_CREATION_ROUTE,
        pageName: 'auction_multicreation',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...MultiCreationAuctionRequirements,
    },
    {
        title: 'BannersPage.title',
        component: BannersPage,
        path: `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/banners`,
        pageName: 'clickme_campaign_banners',
        sendScreenShownAnalytics: false,
        type: RouteType.UserRoute,
        xs: true,
        exact: true,
        ...BannersPageRequirements,
    },
    {
        title: 'AdCreate.pageTitle',
        component: CpcFlexibleBuilderPage,
        path: `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/`,
        pageName: 'clickme_edit_campaign',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...CpcFlexibleBuilderPageRequirements,
    },
    {
        title: 'AdCreate.pageTitle',
        component: AdCopyPage,
        path: `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/banner/:${BANNER_ID_URL_FIELD_NAME}/copy`,
        pageName: 'clickme_copy_campaign',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...AdCopyPageRequirements,
    },
    {
        title: 'BannerForm.pageTitle',
        component: BannerBuilderPage,
        path: `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/banner/`,
        pageName: 'clickme_create_banner',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...BannerBuilderPageRequirements,
    },
    {
        title: 'Statistic.pageTitle',
        component: Statistic,
        path: `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/statistics/`,
        pageName: 'clickme_campaigns_statistics',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...StatisticRequirements,
    },
    {
        title: 'Statistic.pageTitle',
        component: Statistic,
        path: `/new/banner/:${BANNER_ID_URL_FIELD_NAME}/statistics/`,
        pageName: 'clickme_banner_statistics',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...StatisticRequirements,
    },
    {
        title: 'BannerForm.pageTitle',
        component: BannerBuilderPage,
        path: `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/banner/:${BANNER_ID_URL_FIELD_NAME}/`,
        pageName: 'clickme_edit_banner',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        ...BannerBuilderPageRequirements,
    },
    {
        component: LandingPageStub,
        path: '/new/',
        pageName: 'clickme_stub',
        type: RouteType.PublicRoute,
        ...EmptyRequirements,
    },
    {
        title: 'Login.pageTitle',
        component: LoginPage,
        path: '/new/login/',
        pageName: 'clickme_login',
        type: RouteType.PublicRoute,
    },
    {
        title: 'admin.Users.title',
        path: '/new/admin',
        type: RouteType.InternalRedirect,
        exact: true,
        to: '/new/admin/users',
    },
    {
        title: 'admin.actsReport.title',
        component: ActsReport,
        path: '/new/admin/acts-report/',
        pageName: 'clickme_admin_report_acts',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'Admin.Report.ActsSummaryReport.title',
        component: ActsSummaryReport,
        path: '/new/admin/acts-summary-report/',
        pageName: 'clickme_admin_report_acts_summary',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'admin.SectionTabs.invoiceManual',
        component: ManualChargesReport,
        path: '/new/admin/manual-charges-report/',
        pageName: 'clickme_admin_report_manual_charges',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'admin.SectionTabs.overflow',
        component: OverflowReport,
        path: '/new/admin/overflow-report/',
        pageName: 'clickme_admin_report_overflow',
        type: RouteType.AdminRoute,
    },
    {
        title: 'admin.SectionTabs.campaignsReport',
        component: CampaignsReport,
        path: '/new/admin/campaigns-report/',
        pageName: 'clickme_admin_report_campaigns',
        type: RouteType.AdminRoute,
    },
    {
        title: 'admin.SectionTabs.monthlyIncomeExpense',
        component: IncomeExpenseReport,
        path: '/new/admin/income-expense-report/',
        pageName: 'clickme_admin_report_income_expense',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'admin.SectionTabs.billingFunnel',
        component: BillingFunnelReport,
        path: '/new/admin/billing-funnel-report/',
        pageName: 'clickme_admin_report_billing_funnel',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'admin.SectionTabs.efficiency',
        component: EfficiencyReport,
        path: '/new/admin/efficiency-report/',
        pageName: 'clickme_admin_report_efficiency',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'admin.SectionTabs.accountStatistics',
        component: AccountStatisticsReport,
        path: '/new/admin/account-statistics-report/',
        pageName: 'clickme_admin_report_account_statistics',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'admin.Users.title',
        component: UsersPage,
        path: '/new/admin/users/',
        pageName: 'clickme_admin_users',
        type: RouteType.AdminRoute,
    },
    {
        title: 'admin.UserDetail.title',
        component: UserDetailPage,
        path: '/new/admin/users/:userId/',
        pageName: 'clickme_admin_user_detail',
        type: RouteType.SuperAdminRoute,
        ...UserDetailRequirements,
    },
    {
        title: 'admin.Invoices.title',
        component: Invoices,
        path: '/new/admin/invoices/',
        pageName: 'clickme_admin_invoices',
        type: RouteType.AdminRoute,
    },
    {
        title: 'InvoiceDetail.pageTitle',
        component: InvoiceDetail,
        path: '/new/admin/invoices/:invoiceId/',
        pageName: 'clickme_admin_invoice_detail',
        type: RouteType.SuperAdminRoute,
        ...InvoiceDetailRequirements,
    },
    {
        title: 'Admin.CrmActivity.title',
        component: CrmActivity,
        path: '/new/admin/crm/:crmId/',
        pageName: 'clickme_admin_crm_detail',
        type: RouteType.SuperAdminRoute,
        ...CrmActivityRequirements,
    },
    {
        title: 'admin.CrmActivities.title',
        component: CrmActivities,
        path: '/new/admin/crm/',
        pageName: 'clickme_admin_crm',
        type: RouteType.SuperAdminRoute,
        ...CrmActivitiesRequirements,
    },
    {
        title: 'admin.SectionTabs.translations',
        component: Translations,
        path: '/new/admin/translations/',
        pageName: 'clickme_admin_translations',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'admin.SectionTabs.editingActs',
        component: EditingActs,
        path: '/new/admin/editing-acts/',
        pageName: 'clickme_admin_editing_acts',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'admin.SectionTabs.promoCodes',
        component: PromoCodesPage,
        path: '/new/admin/promo-codes/',
        pageName: 'clickme_admin_promo_codes',
        type: RouteType.SuperAdminRoute,
        ...PromoCodesRequirements,
    },
    {
        title: 'SubscriptionSettings.title',
        component: SubscriptionSettingsPage,
        path: '/new/settings/',
        pageName: 'clickme_mail_settings',
        sendScreenShownAnalytics: true,
        type: RouteType.UserRoute,
        xs: true,
        ...SubscriptionSettingsRequirements,
    },
    {
        title: 'admin.SectionTabs.payers',
        component: Payers,
        path: '/new/admin/payers/',
        pageName: 'clickme_admin_payers',
        type: RouteType.SuperAdminRoute,
        ...PayersRequirements,
    },
    {
        title: 'admin.PayerDetail.title',
        component: PayerDetail,
        path: '/new/admin/payers/:payerId',
        pageName: 'clickme_admin_payer_detail',
        type: RouteType.SuperAdminRoute,
        ...PayerDetailRequirements,
    },
    {
        title: 'admin.PayerCreate.title',
        component: PayerCreate,
        path: '/new/admin/payer/create/',
        pageName: 'clickme_admin_create_payer',
        type: RouteType.SuperAdminRoute,
        ...PayerCreateRequirements,
    },
    {
        title: 'admin.ModerationList.title',
        component: ModerationListPage,
        path: '/new/admin/moderation-list/',
        pageName: 'clickme_admin_moderation_list',
        type: RouteType.ModeratorRoute,
        ...ModerationListPageRequirements,
    },
    {
        title: 'admin.moderationReasonsList.title',
        component: ModerationReasonsListPage,
        path: '/new/admin/moderation-reasons-list/',
        pageName: 'clickme_admin_moderation_reasons_list',
        type: RouteType.ModeratorRoute,
        ...ModerationReasonsListPageRequirements,
    },
    {
        title: 'admin.bannerModerationInfo.title',
        component: BannerModerationInfoPage,
        path: '/new/admin/banner-info/',
        pageName: 'clickme_admin_banner_moderation_info',
        type: RouteType.ModeratorRoute,
    },
    {
        title: 'admin.SectionTabs.directReport',
        component: YandexDirectReportPage,
        path: '/new/admin/yandex-direct-report/',
        pageName: 'clickme_admin_direct_report',
        type: RouteType.SuperAdminRoute,
    },
    {
        title: 'account.create.title',
        component: AccountCreatePage,
        path: '/new/account/create/',
        pageName: 'clickme_create_account',
        xs: true,
        type: RouteType.UserRoute,
        ...AccountCreateRequirements,
    },
    {
        title: 'account.edit.title',
        component: AccountCreatePage,
        path: '/new/account/:accountId/',
        pageName: 'clickme_edit_account',
        type: RouteType.UserRoute,
        ...AccountCreateRequirements,
    },
    {
        title: 'accounts.control.title',
        component: AccountsControlPage,
        path: '/new/accounts/control/',
        pageName: 'clickme_accounts_control',
        xs: true,
        type: RouteType.UserRoute,
        ...AccountsControlRequirements,
    },
    {
        title: 'BalanceAndBonuses.header',
        component: BalanceAndBonusesPage,
        path: TOP_UP_PAGE_ROUTE,
        pageName: 'balance_and_bonuses',
        sendScreenShownAnalytics: true,
        xs: true,
        type: RouteType.UserRoute,
        ...BalanceAndBonusesRequirements,
    },
    {
        title: 'forbidden.title',
        component: Forbidden,
        path: '/new/forbidden/',
        pageName: 'clickme_forbidden',
        xs: true,
        type: RouteType.PublicRoute,
    },
    {
        title: 'serverError.title',
        component: ServerError,
        path: '/new/error/',
        pageName: 'clickme_error',
        xs: true,
        type: RouteType.UserRoute,
    },
    {
        title: 'Unavailable.title',
        component: Unavailable,
        path: '/new/unavailable/',
        pageName: 'clickme_unavailable',
        xs: true,
        type: RouteType.PublicRoute,
    },
    {
        title: 'Engineering.Works.title',
        component: EngineeringWorks,
        path: '/new/engineering-works/',
        pageName: 'clickme_engineering_works',
        xs: true,
        type: RouteType.PublicRoute,
    },
    {
        path: '/new/invoice/history/',
        to: TOP_UP_PAGE_ROUTE,
        type: RouteType.ExternalRedirect,
    },
    {
        path: '/new/invoice/create/',
        to: TOP_UP_PAGE_ROUTE,
        type: RouteType.ExternalRedirect,
    },
    {
        path: '/new/acts/',
        to: TOP_UP_PAGE_ROUTE,
        type: RouteType.ExternalRedirect,
    },
    {
        path: '/new/help/:activeTab/',
        to: HELP_PAGE_URL,
        type: RouteType.ExternalRedirect,
    },
    NotFoundRoute,
];
